import { connect } from 'react-redux';
import { updateSchemaSpec, deleteSchemaSpec } from '../../../actions';
import SchemaSpecDetailActions from './SchemaSpecDetailActions';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

function SchemaSpecDetailActionsWithContext(props) {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();
  return <SchemaSpecDetailActions {...props} openDetailDrawerInPortal={openDetailDrawerInPortal} />;
}

export default connect(null, { updateSchemaSpec, deleteSchemaSpec })(
  SchemaSpecDetailActionsWithContext,
);
